import React from 'react';
import { motion } from 'framer-motion';
import { useMouseMoveUI } from '../../../contexts/mouse-move-context';
import {EMAIL, PHONE, PHONE_STRING} from "../../../utils/Constants";

const CtaArea = () => {
    const { mouseDirection, mouseReverse } = useMouseMoveUI();
    return (
        <div className="home-one-cta-two cta-area-1">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-8">
                        <div className="home-one-cta edu-cta-box bg-image">
                            <div className="inner">
                                <div className="content text-md-end">
                                    <span className="subtitle">Bizimle İletişime Geçin:</span>
                                    <h5 className="title">
                                        <a style={{fontSize:"20px"}} href={`mailto:${EMAIL}`}>{EMAIL}</a>
                                    </h5>
                                </div>
                                <div className="sparator">
                                    <span>veya</span>
                                </div>
                                <div className="content">
                                    <span className="subtitle">Bizi Arayın:</span>
                                    <h5 className="title">
                                        <a style={{fontSize:"20px"}} href={`tel:${PHONE}`}>{PHONE_STRING}</a>
                                    </h5>
                                </div>
                            </div>
                            <ul className="shape-group">
                                <motion.li className="shape-01 scene"
                                    animate={ {
                                        x: mouseReverse(50).x,
                                        y: mouseReverse(50).y
                                    } }
                                >
                                    <img src="/assets/images/cta/shape-06.png" alt="shape" />
                                </motion.li>
                                <motion.li className="shape-02 scene"
                                    animate={ {
                                        x: mouseDirection(50).x,
                                        y: mouseDirection(50).y
                                    } }
                                >
                                    <img src="/assets/images/cta/shape-12.png" alt="shape" />
                                </motion.li>
                                <motion.li className="shape-03 scene"
                                    animate={ {
                                        x: mouseDirection(50).x,
                                        y: mouseDirection(50).y
                                    } }
                                >
                                    <img src="/assets/images/cta/shape-04.png" alt="shape" />
                                </motion.li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CtaArea;